import { useState } from 'react';
import BuyMenu from './BuyMenu';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from './i18n';
import './App.css';

const imagesPath = process.env.PUBLIC_URL + '/images';
const logo = imagesPath + '/logo.png';
const heroPapaya = imagesPath + '/hero-papaya.jpg';
const productGelPhoto = imagesPath + '/product-gel-photo.png';
const productPhoto = imagesPath + '/product-photo.png';

function App() {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const { href, messages } = useLanguage();
  const copy = messages.app;

  return (
    <div className="page">
      <header className="hero">
        <nav className="topbar" aria-label={messages.navigation}>
          <a className="brand" href={href('/#top')} aria-label={messages.brandPlain}>
            <img src={logo} className="brand-logo" alt={messages.logoAlt} />
            <span>{messages.brand}</span>
          </a>
          <div className="topbar-actions">
            <LanguageSwitcher />
            <BuyMenu />
          </div>
        </nav>

        <section className="hero-banner" aria-label={copy.bannerAria}>
          <img
            src={heroPapaya}
            className="hero-banner-image"
            alt={copy.bannerAlt}
          />
        </section>

        <section className="hero-grid" id="top">
          <div className="hero-content">
            <h1>{copy.title}</h1>
            <button
              className="hero-description-toggle"
              type="button"
              onClick={() => setIsDescriptionOpen((isOpen) => !isOpen)}
            >
              <span className="hero-description-teaser">
                {copy.teaser}
              </span>
              <span className="hero-description-action">
                {isDescriptionOpen ? copy.collapse : copy.expand}
              </span>
            </button>
            {isDescriptionOpen && (
              <div className="hero-description-content">
                <h2>{copy.papainTitle}</h2>
                <p>{copy.papain}</p>

                <h3>{copy.keyProperties}</h3>
                <ul>
                  {copy.properties.map((item) => <li key={item}>{item}</li>)}
                </ul>

                <h3>{copy.effectTitle}</h3>
                <p>{copy.effectIntro}</p>
                <ol>
                  {copy.effects.map((item) => <li key={item}>{item}</li>)}
                </ol>

                <h3>{copy.usesTitle}</h3>
                <ul>
                  {copy.uses.map((item) => <li key={item}>{item}</li>)}
                </ul>

                <h3>{copy.nuancesTitle}</h3>
                <ul>
                  {copy.nuances.map((item) => <li key={item}>{item}</li>)}
                </ul>
              </div>
            )}
          </div>

          <aside className="product-card" aria-label={copy.productCardAria}>
            <div className="product-brand">
              <img src={logo} className="product-brand-logo" alt={messages.logoAlt} />
              <span>{messages.brand}</span>
            </div>
          </aside>
        </section>
      </header>

      <main>
        <section className="section product-photos-section">
          <div className="section-heading">
            <h2>{copy.productsTitle}</h2>
          </div>
          <div className="product-gallery">
            <figure className="product-photo-card">
              <img
                src={productPhoto}
                className="product-photo"
                alt={copy.creamAlt}
              />
              <figcaption>{copy.cream}</figcaption>
              <a className="product-more-button" href={href('/cream')}>
                {copy.more}
              </a>
            </figure>
            <figure className="product-photo-card">
              <img
                src={productGelPhoto}
                className="product-photo"
                alt={copy.gelAlt}
              />
              <figcaption>{copy.gel}</figcaption>
              <a className="product-more-button" href={href('/gel')}>
                {copy.more}
              </a>
            </figure>
          </div>
        </section>

        <section className="notice">
          <strong>{messages.important}</strong> {messages.disclaimer}
        </section>
      </main>
    </div>
  );
}

export default App;
